const DataAnalysisData = [{
    id: "1d",
    category: "데이터분석",
    title: "전력연구원",
    body: `
        한국전력의 전력연구원과 협업하여 화력 발전소의 16,000 개의 운전 센서 데이터를 분석한 프로젝트입니다.
        \n\n
        새로운 비즈니스 도메인에서 다양한 인공지능 분석 기술을 접목, 막대한 규모의 데이터를 분석합니다.
        \n\n
        최적의 데이터를 선별하여 우리의 가설을 잘 검증할 수 있는 최선의 워크로드 구성하여 프로세스를 효율화하였습니다.
        `,
    hashtag: ["#데이터분석", "#python", ],
    img: "./images/4_dataanalysis/01_01.PNG",
    logo: "./images/4_dataanalysis/01_02.png",
    alt: "전력연구원"
}, ]

export default DataAnalysisData;